import React, { useEffect, useState } from "react";
import GetCatalogueProductDetailsService from "../../../../../../../../../../../Service/DashboardServices/AccountOverviewServices/StoreServices/GetCatalogueProductDetailsService";
import { connect } from "react-redux";
import { Row, Col, Card } from "reactstrap";
import CatalogueItemDetails from "../../../../../../../../../Components/Widgets/Products/CatalogueItemDetails";

function ProductCatalogueDetailsFile(props) {
  const [catalogProductDetails, setCatalogProductDetails] = useState(null); // Hold the product details
  const [isLoading, setIsLoading] = useState(false); // Handle loading state

  useEffect(() => {
    const fetchCatalogueDetails = async () => {
      setIsLoading(true); // Start loading
      const response = await GetCatalogueProductDetailsService(
        props.token,
        props.ASIN,
        props.integerID
      );
      if (response) {
        console.log("Fetched Catalogue Product Details:", response);
        setCatalogProductDetails(response); // Save response in state
      }
      setIsLoading(false); // Stop loading
    };

    fetchCatalogueDetails();
  }, [props.token, props.ASIN, props.integerID]);

  return (
    <CatalogueItemDetails data={catalogProductDetails} />
  );
}

const mapStateToProps = (state) => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    UserPermission: state.accountOverview.store.StoreUserPermission,
    storeOverview: state.accountOverview.store.storeOverview,
  };
};

export default connect(mapStateToProps)(ProductCatalogueDetailsFile);
